const swiper = new Swiper(".testimonial-box-wrapper", {
  loop: true,
  speed: 1000,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    type: "progressbar",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 10 },
    390: { slidesPerView: 1.5, spaceBetween: 10 },
    768: { slidesPerView: 2.5, spaceBetween: 20 },
    992: { slidesPerView: 2.5, spaceBetween: 20 },
    1200: { slidesPerView: 2.5, spaceBetween: 20 },
  },
});

$(document).ready(function () {
  // setTimeout(function() { 
  //   $(".custom-model-main.save-model").addClass('model-open');
  //   }, 2000);
  // $(".Click-here").on('click', function() {
  //   $(".custom-model-main").addClass('model-open');
  // }); 
  setTimeout(function() {
         if (!localStorage.getItem('firstLoad')) {
      $(".custom-model-main").addClass('model-open');
      localStorage.setItem('firstLoad', 'true');
    }
      },60000);
    
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });
  
  $('#menu-drawer .menu-drawer__icon-wrapper .icon-close').click(function(){
    $('#Details-menu-drawer-container').removeAttr('open');
    $('#Details-menu-drawer-container').removeClass('menu-opening');
    $('body').removeClass('overflow-hidden-tablet');
    $('#Details-menu-drawer-container summary.header__icon').removeAttr('aria-expanded');
  });
  
  // If transperent
  var transperentElment = document.querySelector(".allow-transparent-header");
  var header = document.querySelector(".header-wrapper");
  if (transperentElment) {
    header.classList.add("allow-transparent-header");
  }

  var swiper_slider = new Swiper(".footer-icon-with-text_swiper", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    grabCursor: true,
    spaceBetween: 0,
    loop: false,
    breakpoints: {
      428: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      480: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      769: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      990: {
        slidesPerView: 4,
        slidesPerGroup: 1,
      },
    },
  });

  if (document.body.clientWidth < 1025) {
    $(".swiper-testi-main-wap").insertAfter(".testimonial-box-wrapper");
    $(".faq_content .button").insertAfter(".faq-section .faq_accordion");
  }

  if (document.body.clientWidth < 750) {
    $(".footer-block__newsletter").insertBefore(
      ".footer-block--brand_information"
    );
  }

  if (document.body.clientWidth < 991) {
    const icon_swiper = new Swiper(".text-with-icon-blocks", {
      loop: true,
      speed: 1000,
      pagination: {
        el: ".text-with-icon-blocks .swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      effect: "slide",
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        400: { slidesPerView: 2, spaceBetween: 10 },
        575: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 30 },
        990: { slidesPerView: 3, spaceBetween: 30 },
      },
    });

    const icon_swiper_1 = new Swiper(".text-with-image-blocks", {
      loop: true,
      speed: 1000,
      pagination: {
        el: ".text-with-image-blocks .swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      effect: "slide",
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        400: { slidesPerView: 2, spaceBetween: 10 },
        575: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 30 },
        990: { slidesPerView: 3, spaceBetween: 30 },
      },
    });

    const topbar_swiper = new Swiper(".announce_cover", {
      loop: true,
      speed: 1000,
      pagination: {
        el: ".announce_cover .swiper-pagination",
        type: "progressbar",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      effect: "slide",
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 30 },
        990: { slidesPerView: 3, spaceBetween: 30 },
      },
    });
  }

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("main_tab_trigger")) {
      var tab_data = event.target.getAttribute("data_handle");

      document
        .querySelectorAll(".main_tab_trigger")
        .forEach(function (element) {
          element.classList.remove("active", "button--primary");
          element.classList.add("button--secondary");
        });

      event.target.classList.add("active", "button--primary");
      event.target.classList.remove("button--secondary");

      document
        .querySelectorAll(".tab-info[data_handle]")
        .forEach(function (element) {
          element.classList.add("hidden");
          element.classList.remove("active", "button--primary");
          element.classList.add("button--secondary");
        });

      var targetTab = document.querySelector(
        '.tab-info[data_handle="' + tab_data + '"]'
      );
      if (targetTab) {
        targetTab.classList.add("active", "button--primary");
        targetTab.classList.remove("active", "button--secondary");
        targetTab.classList.remove("hidden");
      }
    }
  });

  if (document.body.clientWidth < 750) {
    document.querySelectorAll(".accordion-item").forEach((item) => {
      item
        .querySelector(".accordion-item-header")
        .addEventListener("click", () => {
          item.classList.toggle("open");
        });
    });
  }
  
});

// blog
document.addEventListener("DOMContentLoaded", () => {
  // Handle FAQ buttons
  const buttons = document.querySelectorAll(".blog-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove the active class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));

      // Add the active class to the clicked button
      button.classList.add("active");

      // Redirect to the URL specified in the href attribute
      window.location.href = button.getAttribute("href");
    });
  });
});

function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("dropdownIcon");
  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}



// faqs
document.addEventListener("DOMContentLoaded", () => {
  // Handle FAQ buttons
  const buttons = document.querySelectorAll(".faq-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove the active class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));

      // Add the active class to the clicked button
      button.classList.add("active");

      // Redirect to the URL specified in the href attribute
      window.location.href = button.getAttribute("href");
    });
  });
});
 

const faq_page_accordionBtns = document.querySelectorAll(
  ".faq_accordion .accordion"
);

faq_page_accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
      this.nextElementSibling.style.maxHeight = "0px";
    } else {
      $(".faq_accordion .accordion").removeClass("is-open");
      $(".faq_accordion .accordion-content").css("max-height", "0px");
      $(this).addClass("is-open");
      let content = this.nextElementSibling;
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});

const faq_accordionBtns = document.querySelectorAll(
  ".faq-page_main_wrapper .accordion"
);

faq_accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
      this.nextElementSibling.style.maxHeight = "0px";
    } else {
      $(".faq-page_main_wrapper .accordion").removeClass("is-open");
      $(".faq-page_main_wrapper .accordion-content").css("max-height", "0px");
      $(this).addClass("is-open");
      let content = this.nextElementSibling;
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});


// lexikon
  $(document).ready(function() {
    // Click event for accordion header
    $('.accordion-header').click(function() {
      // Find the accordion item that is not this one
      var notthis = $('.accordion-item').not($(this).closest('.accordion-item'));

      // Toggle the other items and icons
      notthis.find('.minus-icon').hide();
      notthis.find('.plus-icon').show();
      notthis.removeClass('active').find('.accordion-content').slideUp();
      
      // Toggle this item
      $(this).closest('.accordion-item').toggleClass('active');
      var content = $(this).closest('.accordion-item').find('.accordion-content');
      content.slideToggle();
      
      // Toggle the icons
      $(this).find('.plus-icon').toggle();
      $(this).find('.minus-icon').toggle();
    });
  });

//lexikon page dynamic js 

document.querySelectorAll('.letter').forEach(letter => {
  letter.addEventListener('click', function(e) {
    e.preventDefault();

    // Get the clicked letter's data-letter attribute value
    const selectedLetter = this.getAttribute('data-letter');

    // Find the corresponding accordion title with matching data-title
    const targetAccordion = document.querySelector(`.according-title[data-title="${selectedLetter}"]`);

    // If a matching accordion title is found, scroll to its parent accordion container
    if (targetAccordion) {
      targetAccordion.closest('.accordion-container').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

//blog hide show using tag 

document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.blog-btn');
  const articles = document.querySelectorAll('.blog-articles__article');
  const noArticlesMessage = document.getElementById('no-articles-message');
  const loadMoreButton = document.getElementById('load-more');
  
  let shownPosts = 6; // Number of posts to show initially
  let currentTag = ''; // Currently active tag

  // Function to show articles based on the selected tag
  function showArticles(tag) {
    let visibleArticlesCount = 0;

    articles.forEach(article => {
      const articleTags = article.getAttribute('data-tags');
      if (articleTags) {
        const tagsArray = articleTags.split(',');
        if (tagsArray.includes(tag)) {
          article.classList.remove('hidden');
          visibleArticlesCount++;
          if (visibleArticlesCount > shownPosts) {
            article.classList.add('hidden');
          }
        } else {
          article.classList.add('hidden');
        }
      } else {
        article.classList.add('hidden');
      }
    });

    // Show or hide the "Load More" button
    if (visibleArticlesCount > shownPosts) {
      loadMoreButton.style.display = 'block';
    } else {
      loadMoreButton.style.display = 'none';
    }

    // Show or hide the no-articles message
    if (visibleArticlesCount > 0) {
      noArticlesMessage.style.display = 'none';
    } else {
      noArticlesMessage.style.display = 'block';
    }

    // Update the active class on the buttons
    buttons.forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.blog-btn[data-blog-title="${tag}"]`).classList.add('active');

    // Reset shown posts when switching tabs
    shownPosts = 6;
    loadMoreButton.style.display = visibleArticlesCount > shownPosts ? 'block' : 'none';
  }

  // Handle tab click
  buttons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const selectedTag = this.getAttribute('data-blog-title');
      currentTag = selectedTag; // Update current tag
      showArticles(selectedTag);
    });
  });

  // Handle "Load More" button click
  $(document).ready(function(){
    $('#load-more').click(function(event){
      event.preventDefault();

      // Show more hidden posts
      let revealedPosts = 0;
      $(".blog-articles__article.hidden").each(function(index) {
        if (index < shownPosts) {
          $(this).removeClass("hidden");
          revealedPosts++;
        }
      });

      // Update the shown posts count
      shownPosts += revealedPosts;

      // Hide the button if no more posts are hidden
      if ($(".blog-articles__article.hidden").length === 0) {
        $('#load-more').hide();
      }
    });

    // Initial load: Show posts for the default active tab
    const defaultTag = document.querySelector('.blog-btn.active').getAttribute('data-blog-title');
    showArticles(defaultTag);
  });
});

//mobile view blog post 

$(document).ready(function() {
  $('.dropdown-content .blog-btn').click(function() {
    // Hide the dropdown menu when a button is clicked
    $('.dropdown-content').css('display', 'none');
    var tagName = $(this).attr('data-title-set');
    console.log("tagName",tagName);
    $('.dropdown-button').text(tagName);
  });
});



// faq content scroll 

 document.addEventListener('DOMContentLoaded', function() {
  const faqButtons = document.querySelectorAll('.faq-btn');

  faqButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const targetTitle = this.getAttribute('data-btn-title');
      const targetSection = document.querySelector(`[data-faq-title="${targetTitle}"]`);

      if (targetSection) {
        //console.log("same******");
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});

// 
/* document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ContactFooter');
  const checkbox = document.getElementById('checkbox');
  const checkboxError = document.getElementById('checkbox-error');

  // Form submission event handler
  form.addEventListener('submit', function(event) {
    // Check if the checkbox is checked
    if (!checkbox.checked) {
      // If not checked, prevent form submission and display error message
      checkboxError.style.display = 'block';
      event.preventDefault(); // Prevent form submission
    } else {
      // If checked, hide error message and allow form submission
      checkboxError.style.display = 'none';
    }
  });

  // Checkbox change event to hide the error when the checkbox is checked
  checkbox.addEventListener('change', function() {
    if (checkbox.checked) {
      checkboxError.style.display = 'none';
    }
  });
}); */

/* $(document).ready(function(){
    $("#ContactFooter").on("submit",function(){
      console.log("submit========");
      if(!$("#checkbox").prop("checked"))
      {
          $(".checkbox-error").removeClass('hidden');        
      }
      else
      {
          $(".checkbox-error").addClass('hidden');
          return true;
      }    
       return false;
  })
}) */
